<template>
  <footer class="footer pb-2 pt-5" style="background-color: #2F2F2F">
    <div class="content has-text-centered">
      <p class="has-text-white">Made by Paweł Włodarczyk <small>&copy;</small></p>
      <a href="http://www.instagram.com/pawelvlodarczyk"><b-icon pack="fab" icon="instagram" size="is-medium" class="has-text-white" /></a>
    </div>
  </footer>
</template>

<script>
export default {
  name: "Footer"
}
</script>

<style scoped>

</style>
